export default __webpack_public_path__ + "static/media/icons8-dashboard-layout (7).26136d8f.svg";